import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingService, NotifierService, Toast } from './core';
import { faCheck, faExclamation } from '@fortawesome/pro-solid-svg-icons';
import { NgbModalConfig, NgbOffcanvasConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  standalone: false,
  styles: [],
  templateUrl: './app.html',
})
export class App implements OnInit, OnDestroy {

  toastSubscription: Subscription;
  loadingSubscription: Subscription;

  toastList = signal<Toast[]>([]);

  private notifierService = inject(NotifierService);
  private loadingService = inject(LoadingService);

  fasExclamation = faExclamation;
  fasCheck = faCheck;

  isBlocked = signal(false);

  constructor() {
    // customize default values of modals used by this component tree
    const modalConfig = inject(NgbModalConfig);
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;

    const offcanvasConfig = inject(NgbOffcanvasConfig);
    offcanvasConfig.backdrop = 'static';
    offcanvasConfig.keyboard = false;
  }

  ngOnInit(): void {
    this.toastSubscription = this.notifierService.toastList().subscribe({
      next: (list) => {
        this.toastList.set(list);
      }
    });

    this.loadingSubscription = this.loadingService.isBlocked().subscribe({
      next: (ct) => {
        this.isBlocked.set(ct > 0);
      }
    });
  }

  ngOnDestroy(): void {
    this.toastSubscription.unsubscribe();
    this.loadingSubscription.unsubscribe();
  }

  closeToast(t: Toast): void {
    this.notifierService.remove(t);
  }
}
